module.exports = __webpack_public_path__ + "static/weekly-candy-retails-5e80e0a91b27cd6732b97e78ff20e103.gif";